import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Result, Button, Layout, Row, Card } from "antd";
import styles from "../styles/Admin.module.css";
const { Header, Content, Footer } = Layout;

function SuccessChangePassword({ title, subTitle, flag, backEvent }) {
  const location = useLocation();
  return (
    <div>
      <div
        style={{
          width: "100%",
          height: "110px",
        }}
      ></div>
      <Result
        status="success"
        title={location?.state?.message} //"Successfully Purchased Contract!"
        subTitle={subTitle} //"Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait."
        extra={
          flag && (
            <Button type="primary" key="console" onClick={backEvent} danger>
              Back
            </Button>
          )
        }
      />
      <div style={{ minHeight: 250, background: "#fff" }}>
        <Card style={{ width: "30%", margin: "auto" }}>
          <Row
            align=""
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItem: "center",
            }}
          >
            <div style={{ marginRight: "5px" }}>Click</div>{" "}
            <Link to={"/"}> here</Link>{" "}
            <div style={{ marginLeft: "5px" }}>
              to return to the Login Panel.
            </div>
          </Row>
        </Card>
      </div>
    </div>
  );
}

export { SuccessChangePassword };
